"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClearContractAdmin = void 0;
var json_1 = require("../../../util/json");
var any_1 = require("@terra-money/terra.proto/google/protobuf/any");
var tx_1 = require("@terra-money/terra.proto/terra/wasm/v1beta1/tx");
var MsgClearContractAdmin = /** @class */ (function (_super) {
    __extends(MsgClearContractAdmin, _super);
    /**
     * @param admin contract admin
     * @param new_admin new admin
     * @param contract contract address
     */
    function MsgClearContractAdmin(admin, contract) {
        var _this = _super.call(this) || this;
        _this.admin = admin;
        _this.contract = contract;
        return _this;
    }
    MsgClearContractAdmin.fromAmino = function (data) {
        var _a = data.value, admin = _a.admin, contract = _a.contract;
        return new MsgClearContractAdmin(admin, contract);
    };
    MsgClearContractAdmin.prototype.toAmino = function () {
        var _a = this, admin = _a.admin, contract = _a.contract;
        return {
            type: 'wasm/MsgClearContractAdmin',
            value: {
                admin: admin,
                contract: contract,
            },
        };
    };
    MsgClearContractAdmin.fromProto = function (data) {
        return new MsgClearContractAdmin(data.admin, data.contract);
    };
    MsgClearContractAdmin.prototype.toProto = function () {
        return tx_1.MsgClearContractAdmin.fromPartial({
            admin: this.admin,
            contract: this.contract,
        });
    };
    MsgClearContractAdmin.prototype.packAny = function () {
        return any_1.Any.fromPartial({
            typeUrl: '/terra.wasm.v1beta1.MsgClearContractAdmin',
            value: tx_1.MsgClearContractAdmin.encode(this.toProto()).finish(),
        });
    };
    MsgClearContractAdmin.unpackAny = function (msgAny) {
        return MsgClearContractAdmin.fromProto(tx_1.MsgClearContractAdmin.decode(msgAny.value));
    };
    MsgClearContractAdmin.fromData = function (data) {
        var admin = data.admin, contract = data.contract;
        return new MsgClearContractAdmin(admin, contract);
    };
    MsgClearContractAdmin.prototype.toData = function () {
        return {
            '@type': '/terra.wasm.v1beta1.MsgClearContractAdmin',
            admin: this.admin,
            contract: this.contract,
        };
    };
    return MsgClearContractAdmin;
}(json_1.JSONSerializable));
exports.MsgClearContractAdmin = MsgClearContractAdmin;
